import { oc } from '@orpc/contract';
import { getTradeInInputSchema, tradeInOutputSchema } from '../schemas/trade-in.schemas.js';
/** `null` until somebody records one; a direct purchase never has a trade-in case. */
export const getTradeInContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/trade-in',
    tags: ['Trade-in'],
    summary: 'Read the trade-in case of a stock vehicle',
})
    .input(getTradeInInputSchema)
    .output(tradeInOutputSchema);
//# sourceMappingURL=get-trade-in.contract.js.map